import { Box, Container, Typography } from "@mui/material";
import React from "react";
import RoleSelectCards, { INTAKE_PATH_BY_ROLE } from "../components/RoleSelectCards";
import { Reveal } from "../theme/animation";
import HeroSection from "../theme/HeroSection";

const Contact: React.FC = () => {
    return (
        <Box>
            <HeroSection minHeight="40vh" showWave={true} imageUrl="/images/SeanValentine-HGP.jpg" animateHero>
                <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                    <Box sx={{ maxWidth: 640 }}>
                        <Reveal variant="fadeUp" trigger="mount">
                            <Typography
                                variant="h3"
                                component="h1"
                                sx={{
                                    color: "white",
                                    fontWeight: "bold",
                                    fontSize: { xs: "1.75rem", sm: "2rem", md: "2.25rem" }
                                }}
                            >
                                Connect with us
                            </Typography>
                        </Reveal>
                    </Box>
                </Container>
            </HeroSection>

            <Container maxWidth="lg" sx={{ py: 8 }} id="select-your-role">
                <Reveal variant="fadeUp">
                    <Typography
                        variant="h5"
                        component="h2"
                        sx={{ textAlign: "center", mb: 4, fontWeight: "bold", fontStyle: "italic" }}
                    >
                        Select a role so you contact the right team.
                    </Typography>
                </Reveal>
                <RoleSelectCards pathByRole={INTAKE_PATH_BY_ROLE} />
            </Container>
        </Box>
    );
};

export default Contact;
